export const CLASS_NAMES = {
	setupActivationCard:
		'flex flex-col gap-6 rounded-[24px] bg-white p-6 text-left shadow-none md:min-h-[347px] md:flex-row md:items-stretch',
	setupActivationContent: 'flex min-w-0 flex-1 flex-col justify-between gap-10',
	setupActivationCopy: 'flex flex-col gap-[23px]',
	setupActivationHeader: 'flex flex-col items-start gap-[30px]',
	setupActivationCheckIcon: 'h-[34px] w-[34px] text-[#0FA954]',
	setupActivationTitle:
		'max-w-[468px] text-[32px] font-normal leading-10 text-[#0FA954]',
	setupActivationDescription:
		'max-w-[468px] text-base font-normal leading-6 text-[var(--color-primary-900)]',
	setupCompleteModalContent:
		'!overflow-hidden !rounded-[12px] !border !border-[var(--color-primary-600)] !bg-white !shadow-none',
	setupCompleteModalBody: '!p-0',
	setupCompleteCard:
		'relative overflow-hidden bg-white text-left text-[var(--color-primary-900)]',
	setupCompleteHeader: 'px-6 pb-4 pt-6',
	setupCompleteHeaderTop: 'mb-4 flex items-start justify-between gap-4',
	setupCompleteCloseButton:
		'inline-flex h-8 w-8 items-center justify-center rounded-full text-[var(--color-primary-900)] transition-colors hover:bg-[var(--color-primary-50)] disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent',
	setupCompleteCloseIcon: 'h-5 w-5',
	setupCompleteContent: 'flex flex-col gap-[22px] px-8 pb-6 pt-[44px]',
	setupCompletePhoneIcon: 'h-[26px] w-[18px] text-[#63799B]',
	setupCompleteCallTitle:
		'text-[30px] font-normal leading-[39px] text-[var(--color-primary-900)]',
	setupCompletePhoneNumberInline:
		'inline-flex items-center gap-2 align-baseline',
	setupCompleteCopyButton:
		'inline-flex h-8 w-8 items-center justify-center rounded-full align-middle text-[var(--color-primary-900)] transition-colors hover:bg-[var(--color-primary-50)]',
	setupCompleteCopyIcon: 'h-4 w-4',
	setupCompleteVideo:
		'block h-[clamp(320px,42vh,400px)] w-full border-t border-[var(--color-primary-100)] bg-white object-cover object-center',
	setupCompleteCallStartedImage:
		'block h-[clamp(320px,42vh,400px)] w-full border-t border-[var(--color-primary-100)] bg-white object-contain object-center',
	setupCompleteChecklist:
		'list-disc pl-4 text-base font-normal leading-[23px] text-[var(--color-primary-900)]',
	setupCompleteWaitingStatus:
		'inline-flex w-fit items-center gap-2 text-base font-semibold leading-5 text-[var(--color-primary-600)]',
	setupCompleteWaitingIcon: 'h-5 w-5 shrink-0 text-[var(--color-primary-600)]',
	setupCompleteWaitingText: 'text-[var(--color-primary-600)]',
	setupCompleteProfile:
		'flex w-full flex-col items-center justify-between overflow-hidden rounded-2xl bg-[var(--color-primary-50)] p-4 md:w-[420px] md:shrink-0 md:self-stretch',
	setupCompleteProfileIdentity: 'flex flex-col items-center gap-4',
	setupCompleteAvatar:
		'h-[142px] w-[142px] overflow-hidden rounded-full bg-[#F9D7E3]',
	setupCompleteAgentName:
		'text-center text-[32px] font-normal leading-10 text-[var(--color-primary-900)]',
	setupCompletePhoneBlock:
		'mt-8 flex flex-col items-center text-center md:mt-0',
	setupCompletePhoneLabel:
		'text-base leading-6 text-[var(--color-primary-900)]',
	setupCompletePhoneNumber:
		'text-xl font-semibold leading-[30px] text-[var(--color-primary-900)]',
	setupCompleteActions: 'flex flex-wrap items-center gap-1',
	setupPrimaryAction:
		'inline-flex h-12 items-center justify-center rounded-full bg-[var(--color-primary-800)] px-6 text-base font-semibold leading-5 text-white transition-colors hover:bg-[var(--color-primary-800)]',
	setupSecondaryAction:
		'inline-flex h-12 items-center justify-center rounded-full px-6 text-base font-semibold leading-5 text-[var(--color-primary-800)] transition-colors hover:bg-[var(--color-primary-50)]'
} as const;
